import CroppedMediaPreview from '@/components/mediaBuying/adCreatives/screens/mediaCrop/adAssetCropPreview/index.jsx'
import { constructProxyUrl } from '@/utils/proxy.js'

export const imageWrapperStyles = (ratio = '') => ({
    aspectRatio: ratio.replace(':', ' / '),
    overflow: 'hidden',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#3B5168',
})

export const Media = ({
    type,
    url,
    cropData,
    aspectRatio,
    canvasWidth,
    canvasHeight,
    isProxied = false,
    autoStart = true,
    minWidth,
    minHeight,
    startTime,
    endTime,
    thumbnails,
    startMuted = true,
}) => {
    const thisUrl = isProxied ? url : constructProxyUrl(url)

    return (
        <CroppedMediaPreview
            type={type}
            url={thisUrl}
            cropData={cropData}
            aspect={aspectRatio}
            width={canvasWidth}
            height={canvasHeight}
            autoStart={autoStart}
            minWidth={minWidth}
            minHeight={minHeight}
            startTime={startTime}
            endTime={endTime}
            thumbnails={thumbnails}
            startMuted={startMuted}
        />
    )
}
